module.exports = __webpack_public_path__ + "169a66ec2bdbfbd75dfd49f475fd677d.fbx";